/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Event_Groups_LabelInputs */

const en_merge_event_group_event_groups_label = /** @type {(inputs: Merge_Event_Group_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Groups`)
};

const fr_merge_event_group_event_groups_label = /** @type {(inputs: Merge_Event_Group_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupes d'evenements`)
};

const de_merge_event_group_event_groups_label = /** @type {(inputs: Merge_Event_Group_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppen`)
};

const it_merge_event_group_event_groups_label = /** @type {(inputs: Merge_Event_Group_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppi di eventi`)
};

const ru_merge_event_group_event_groups_label = /** @type {(inputs: Merge_Event_Group_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группы мероприятий`)
};

const es_merge_event_group_event_groups_label = /** @type {(inputs: Merge_Event_Group_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de eventos`)
};

const zh_cn2_merge_event_group_event_groups_label = /** @type {(inputs: Merge_Event_Group_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组`)
};

const ja_merge_event_group_event_groups_label = /** @type {(inputs: Merge_Event_Group_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループ`)
};

const hi_merge_event_group_event_groups_label = /** @type {(inputs: Merge_Event_Group_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह`)
};

const pt_pt2_merge_event_group_event_groups_label = /** @type {(inputs: Merge_Event_Group_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de eventos`)
};

/**
* | output |
* | --- |
* | "Event Groups" |
*
* @param {Merge_Event_Group_Event_Groups_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_event_groups_label = /** @type {((inputs?: Merge_Event_Group_Event_Groups_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Event_Groups_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_event_groups_label(inputs)
	if (locale === "de") return de_merge_event_group_event_groups_label(inputs)
	if (locale === "it") return it_merge_event_group_event_groups_label(inputs)
	if (locale === "ru") return ru_merge_event_group_event_groups_label(inputs)
	if (locale === "es") return es_merge_event_group_event_groups_label(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_event_groups_label(inputs)
	if (locale === "ja") return ja_merge_event_group_event_groups_label(inputs)
	if (locale === "hi") return hi_merge_event_group_event_groups_label(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_event_groups_label(inputs)
	return en_merge_event_group_event_groups_label(inputs)
});